// 课程表
export const COURSE_TABLE_LIST_REQUEST = 'COURSE_TABLE_LIST_REQUEST';
export const MONTH_SCHEDULE_LIST_REQUEST = 'MONTH_SCHEDULE_LIST_REQUEST';
